import {atom} from "recoil";

/**
 * 휴가 결재 상신함 문서 상태
 * @type {RecoilState<number>}
 */
export const vacationStoreState = atom({
    key: "vacationStoreState"
    , default: {
        nowPage: 1,
        docsNum: 10,
        ascending: 'DESC',
        searchEndStart: '',
        searchEndEnd: '',
        searchStartStart: '',
        searchStartEnd: '',
        searchName: '',
        searchTeam: '',
        searchCategory: '',
        searchOveruse: 0,
        approvedList: ['AP005'],
    }
})